import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Tooltip from '../molecules/Tooltip';
import css from './Tabs.css';
import { tabsShape } from './types';
import Icon, { IconVariants } from '../foundations/Icon';

const Tabs = ({
    tabs = [],
    selected = 'regular',
    containerStyle = {},
    dividerStyle = {},
    onClick = () => {},
    containerClass = '',
    tabClass = '',
    activeTabClass = '',
    tabLabelContainerClass = '',
    dataTestId,
}) => {
    const handleClick = (e, tabId) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(tabId);
    };

    const getTab = tab => {
        const isActiveTab = tab.id === selected;

        const tabElement = (
            <button
                type="button"
                className={classNames(tabClass, css.tab, {
                    [css.disabled]: tab.disable,
                    [css.activeTab]: isActiveTab,
                    [activeTabClass]: activeTabClass && isActiveTab,
                })}
                onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleClick(e, tab.id);
                }}
                key={tab.id}
                disabled={tab.disable}
            >
                <div style={tab.style} className={classNames(tabLabelContainerClass, css.tabLabelContainer)}>
                    {tab.icon && <tab.icon className={css.tabIcon} />}
                    {tab.iconName && (
                        <Icon name={tab.iconName} variant={isActiveTab ? IconVariants.ACTIVE : IconVariants.DARK} />
                    )}
                    <div className={classNames(css.tabLabel, tab.tabLabelClass)}>
                        <Translate id={tab.label} data={tab.labelData} />
                    </div>
                </div>
            </button>
        );

        return tab.tooltipText ? (
            <Tooltip key={tab.id} className={css.toolTip} titleTranslationKey={tab.tooltipText}>
                {tabElement}
            </Tooltip>
        ) : (
            tabElement
        );
    };

    return (
        tabs.length > 0 && (
            <div
                className={classNames(css.container, containerClass)}
                style={{
                    ...containerStyle,
                }}
                data-testid={dataTestId}
            >
                {tabs.map(getTab)}
                <div className={css.divider} style={dividerStyle} />
            </div>
        )
    );
};

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape(tabsShape)),
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func,
    containerClass: PropTypes.string,
    tabClass: PropTypes.string,
    activeTabClass: PropTypes.string,
    tabLabelContainerClass: PropTypes.string,
    containerStyle: PropTypes.objectOf(PropTypes.any),
    dividerStyle: PropTypes.objectOf(PropTypes.any),
    dataTestId: PropTypes.string,
};

export default Tabs;
